import { LocalStorageService, LocalStorageKey } from '@template/utils';
import { User } from '@/types/store/user.types';
import { reactive, ref, computed } from 'vue';
import { defineStore } from 'pinia';

export const useUserStore = defineStore('user', () => {
  const user = reactive<User>({
    name: '',
    email: '',
    phone: '',
    lastLogin: '',
  });

  // 로그인 상태를 ref로 관리하여 반응형 유지
  const getInitialLoginStatus = () => {
    const token = LocalStorageService.getItem(LocalStorageKey.ACCESS_TOKEN);
    return !!(token && typeof token === 'string' && token.length > 0);
  };
  const isLoggedIn = ref(getInitialLoginStatus());

  // localStorage 스토리지 이벤트 리스너 등록
  const updateLoginStatus = () => {
    const token = LocalStorageService.getItem(LocalStorageKey.ACCESS_TOKEN);
    // 토큰이 문자열이고 비어있지 않은지 확인
    isLoggedIn.value = !!(token && typeof token === 'string' && token.length > 0);
  };

  // localStorage 변경 감지를 위한 이벤트 리스너
  if (typeof window !== 'undefined') {
    window.addEventListener('storage', updateLoginStatus);
  }

  const email = computed(() => {
    return user.email;
  });

  const updateUserEmail = (email: string) => {
    user.email = email;
  };
  /**
   * 로그인 상태 확인 함수
   * @returns 로그인되어 있으면 true, 아니면 false
   */
  const checkLoggedIn = (): boolean => {
    updateLoginStatus(); // 최신 상태로 업데이트
    return isLoggedIn.value;
  };

  return {
    isLoggedIn,
    checkLoggedIn,
    updateLoginStatus,
    email,
    updateUserEmail,
  };
});
